"use client";

import React from "react";
import { openIntercom } from "@/lib/intercom";
import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface ErrorAlertProps {
  message: string;
  /** Optional support reference code (e.g. last 8 chars of a WorkOS Radar attemptId). When present, the alert renders a Contact Support button that opens the Intercom widget. */
  supportRef?: string;
}

export default function ErrorAlert({ message, supportRef }: ErrorAlertProps) {
  const handleContactSupport = () => {
    openIntercom();
  };

  return (
    <Alert variant="destructive" aria-live="polite">
      <div className="flex items-start text-sm">
        <svg
          className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        <span className="flex-1">{message}</span>
      </div>

      {supportRef && (
        <div className="mt-3 flex items-center justify-between gap-3 pl-7 text-xs">
          <span className="text-xs font-mono">
            Reference: {supportRef}
          </span>
          <Button
            variant="inline"
            size="inline"
            onClick={handleContactSupport}
            data-testid="feature-action"
            className="gap-1.5 underline-offset-2"
          >
            <svg
              className="w-3.5 h-3.5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            Contact support
          </Button>
        </div>
      )}
    </Alert>
  );
}
